module.exports = __webpack_public_path__ + "static/media/isabella-mobile.5d6a5c32.jpg";